// @flow
import * as React from "react"
import FooterLinks from "components/FooterLinks"
import { WhiteWrap } from "componentsStyled/Layout/WhiteWrap"
import { HPaddedFullWidthContainer } from "componentsStyled/Layout/Containers"
import { FooterMargin } from "componentsStyled/Layout/Spacers"

const SectionFooter = () => (
  <WhiteWrap>
    <HPaddedFullWidthContainer>
      <FooterLinks />
      <FooterMargin />
    </HPaddedFullWidthContainer>
  </WhiteWrap>
)

export default SectionFooter



// WEBPACK FOOTER //
// ./src/components/SectionFooter/index.js